/**
 *
 * @param props
 */
export function simulateHigherLevelEntryContract(props) {
    return Object.assign({ description: null, die: null, extendedAoe: null, level: null, targets: 0, totalCount: 0, range: null }, props);
}
